import AppHeader from '../AppHeader'

export default {
  name: 'moral_start',
  created () {
    this.search()
  },
  data () {
    return {
      callbackFlag: false
    }
  },
  computed: {
    moralResult () {
      return this.$store.getters.moralResult
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var self = this
      var data = {}
      var callback = function() {
        self.callbackFlag = true
      }
      this.$store.dispatch('MORAL_GET',  {id: window.localStorage.getItem('user_id'), data: data, callback: callback})
    },
    goMoralCheck: function () {
      if (this.moralResult.attributes['is-all-answered'] == 1) {
        this.$router.push({ path: '/moral_check_list/'})
      } else {
        this.$router.push({ path: '/moral_check/999'})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-start.js